var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgW1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.1735 20.9585L35.9114 16.1025L36.5053 9.67448L30.1996 8.24215L26.8982 2.6875L20.9593 5.23775L15.0204 2.6875L11.719 8.24215L5.41328 9.65701L6.00717 16.085L1.74512 20.9585L6.00717 25.8144L5.41328 32.2599L11.719 33.6922L15.0204 39.2469L20.9593 36.6791L26.8982 39.2294L30.1996 33.6748L36.5053 32.2424L35.9114 25.8144L40.1735 20.9585ZM17.4658 29.6922L10.4788 22.7052L12.9418 20.2423L17.4658 24.7489L28.9769 13.2378L31.4398 15.7182L17.4658 29.6922Z",
    fill: "#007AFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgW1);
export default __webpack_public_path__ + "static/media/w1.001b5d2152be1e86ab0fc46b33e662fe.svg";
export { ForwardRef as ReactComponent };